import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const ContactPage = () => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="min-h-screen bg-deepDark pt-20 pb-32">
      <div className="max-w-5xl mx-auto px-4">
        
        <div className="text-center mb-20">
          <p className="text-gold text-[10px] tracking-widest uppercase mb-4">Private Consultations</p>
          <h1 className="text-5xl md:text-6xl font-serif text-white tracking-wide mb-8">Contact Our Concierge</h1>
          <div className="w-16 h-[1px] bg-gold mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="space-y-12">
            <p className="text-textMuted font-light leading-relaxed mb-12">
              For bespoke inquiries, collection viewing appointments, or assistance with a current acquisition, our dedicated concierge team is available to provide unparalleled white-glove service.
            </p>

            <div className="bg-surfaceDark border border-white/5 p-8 flex items-start gap-6 group hover:border-gold/30 transition-colors">
              <FaMapMarkerAlt className="text-gold text-2xl mt-1" />
              <div>
                <h3 className="text-white font-serif tracking-widest uppercase mb-2">Flagship Boutique</h3>
                <p className="text-sm text-textMuted font-light">123 Rue de la Paix<br/>Paris, France 75002<br/>By Appointment Only</p>
              </div>
            </div>

            <div className="bg-surfaceDark border border-white/5 p-8 flex items-start gap-6 group hover:border-gold/30 transition-colors">
              <FaPhone className="text-gold text-2xl mt-1" />
              <div>
                <h3 className="text-white font-serif tracking-widest uppercase mb-2">Direct Line</h3>
                <p className="text-sm text-textMuted font-light">+33 1 23 45 67 89<br/>Available Mon-Sat, 10am-7pm CET</p>
              </div>
            </div>

            <div className="bg-surfaceDark border border-white/5 p-8 flex items-start gap-6 group hover:border-gold/30 transition-colors">
              <FaEnvelope className="text-gold text-2xl mt-1" />
              <div>
                <h3 className="text-white font-serif tracking-widest uppercase mb-2">Digital Correspondence</h3>
                <p className="text-sm text-textMuted font-light">concierge@luxejewels.com</p>
              </div>
            </div>
          </div>

          <div className="bg-surfaceDark border border-white/5 p-10 lg:p-12">
            <h2 className="text-2xl font-serif text-white mb-8 tracking-wide">Submit Inquiry</h2>
            <form className="space-y-8">
              <div>
                <label className="block text-[10px] tracking-widest uppercase text-textMuted mb-2">Name</label>
                <input type="text" className="w-full bg-transparent border-b border-white/20 text-white px-0 py-2 focus:outline-none focus:border-gold transition-colors font-light text-sm" />
              </div>
              <div>
                <label className="block text-[10px] tracking-widest uppercase text-textMuted mb-2">Email Address</label>
                <input type="email" className="w-full bg-transparent border-b border-white/20 text-white px-0 py-2 focus:outline-none focus:border-gold transition-colors font-light text-sm" />
              </div>
              <div>
                <label className="block text-[10px] tracking-widest uppercase text-textMuted mb-2">Subject</label>
                <select className="w-full bg-deepDark border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-gold transition-colors font-light text-sm appearance-none">
                  <option>Bespoke Commission</option>
                  <option>Arrange Viewing</option>
                  <option>Acquisition Support</option>
                  <option>Other Inquiry</option>
                </select>
              </div>
              <div>
                <label className="block text-[10px] tracking-widest uppercase text-textMuted mb-2">Message</label>
                <textarea rows="4" className="w-full bg-transparent border-b border-white/20 text-white px-0 py-2 focus:outline-none focus:border-gold transition-colors font-light text-sm resize-none"></textarea>
              </div>
              <button type="button" className="w-full bg-gold text-deepDark font-bold py-4 text-xs tracking-widest uppercase hover:bg-white transition-colors duration-300 mt-4">
                Send Correspondence
              </button>
            </form>
          </div>
        </div>

      </div>
    </motion.div>
  );
};

export default ContactPage;
